const ORDERS_TYPE = {
  struct: {
    PEDIDO_UNICO: 'Pedido único',
    UNIQUE_ORDER: 'Unique Order'
  },
  list: () => Object.values(ORDERS_TYPE.struct)
}

const SUBSCRIPTION_TYPE = {
  struct: {
    COBRANCAS_RECORRENTES: 'Assinatura recorrente',
    RECURRING_CHARGES: 'Recurring subscription'
  },
  list: () => Object.values(SUBSCRIPTION_TYPE.struct)
}

const STATUS_CANCEL = {
  struct: {
    INATIVO: 'Inativo',
    CANCELADO: 'Cancelado',
    INACTIVE: 'Inactive',
    CANCELED: 'Canceled'
  },
  list: () =>
    Object.values(STATUS_CANCEL.struct) //
      .map(status => status.toUpperCase())
}

const STATUS_EXPIRE = {
  struct: {
    EXPIRADO: 'Expirado',
    EXPIRED: 'Expired'
  },
  list: () =>
    Object.values(STATUS_EXPIRE.struct) //
      .map(status => status.toUpperCase())
}

const isOrdersType = type => {
  return ORDERS_TYPE.list().includes(type)
}

const isSubscriptionType = type => {
  return SUBSCRIPTION_TYPE.list().includes(type)
}

const isStatusCancelAndExpired = status => {
  return [...STATUS_EXPIRE.list(), ...STATUS_CANCEL.list()].includes(
    status.toUpperCase()
  )
}

export {
  ORDERS_TYPE,
  SUBSCRIPTION_TYPE,
  isOrdersType,
  isSubscriptionType,
  isStatusCancelAndExpired
}
